/*eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import { upperCase } from 'lodash';

const PrivateContext = React.createContext();

const DEFAULT_LABEL = 'Admin Panel';

export const useModuleContext = () => React.useContext(PrivateContext);

export const ModuleRoute = ({ title, component: Component }) => {
  const { setActiveModule } = useModuleContext();
  React.useEffect(() => {
    setActiveModule(title);
    return () => {
      setActiveModule(DEFAULT_LABEL);
    };
  }, [title, setActiveModule]);
  return <Component />;
};

ModuleRoute.defaultProps = {
  children: null,
};

ModuleRoute.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(Object),
};

export const ModuleLabel = () => {
  const { activeModule, subLabel } = useModuleContext();
  return (
    <div className="space-y-2 mb-3 flex-initial">
      <div className=" text-gray-800 font-bold text-2xl">
        {upperCase(activeModule)}
      </div>
      {subLabel && (
        <div className="text-gray-500 font-semibold">{subLabel}</div>
      )}
    </div>
  );
};

function ModuleWrapper({ children }) {
  const [activeModule, setActiveModule] = React.useState(DEFAULT_LABEL);
  const [subLabel, setSubLabel] = React.useState('');
  return (
    <PrivateContext.Provider
      value={{ activeModule, setActiveModule, subLabel, setSubLabel }}
    >
      {children}
    </PrivateContext.Provider>
  );
}

ModuleWrapper.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default ModuleWrapper;
